import { useMembershipModalState } from '../../modalContext';

export function useShowStripePaymentRequestButton(): boolean {
	const [{ acceptMembership, paymentType }] = useMembershipModalState();
	return (paymentType === 'applePay' || paymentType === 'googlePay') && acceptMembership;
}
